import { ceateAtomicPlugin } from '../draftJsFactory';
import QuickReply from './QuickReply';

export default ceateAtomicPlugin(
    'quickReply', 
    QuickReply, 
    { 
        defaultData: {items: []} 
    }
);